var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#53B679"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93896 8.08305L9.84668 9.30815L8.66837 7.5127H7.93896V8.08305Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37451 11.7583L3.00146 11.0288L8.69642 11.7583L2.95451 12.5438L2.37451 11.7583Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63086 3.33241L11.1934 8.34486L10.202 2.86488L9.17336 2.58423L8.63086 3.33241Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7637 6.15666L12.3062 8.30754L12.7737 6.10055L12.2313 5.74512L11.7637 6.15666Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6255 6.56805L13.999 8.6535L15.5231 7.07313L15.2519 6.51196L14.6255 6.56805Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.292 5.75464L15.2051 9.70093L20.2925 6.97961V6.01639L19.292 5.75464Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0293 11.2627L15.8037 11.749L18.0293 12.2352L18.338 11.749L18.0293 11.2627Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3481 17.7153L15.1865 13.825L20.227 16.4435V17.4535L19.3481 17.7153Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5781 17.0981L13.4658 15.05L14.5973 16.9672L14.1858 17.4441L13.5781 17.0981Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7822 17.2759L12.2783 15.1716L12.7644 17.3693L12.2783 17.7621L11.7822 17.2759Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27637 20.9789L8.71533 20.1935L11.212 15.1155L10.2301 20.7452L9.27637 20.9789Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68701 16.5557L8.56543 15.9385L10.1927 14.5825L9.30428 16.5557H8.68701Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34033 15.1998V14.6107L9.39779 13.741L7.93894 15.3495L7.34033 15.1998Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06954 13.9373L8.9587 12.7964L6.62971 13.0208L6.56445 13.6193L7.06954 13.9373Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegen);
export default __webpack_public_path__ + "static/media/regen.246c10490cf964441cb718cad1d5d479.svg";
export { ForwardRef as ReactComponent };